import { render } from "./SubTierSelect.vue?vue&type=template&id=c74e33a8"
import script from "./SubTierSelect.vue?vue&type=script&lang=ts"
export * from "./SubTierSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script